
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileTable } from "./FileTable";
import { FileItem } from "./types";

interface FileListCardProps {
  files: FileItem[];
  editingFile: { id: number; name: string } | null;
  newFileName: string;
  setNewFileName: (name: string) => void;
  saveFileNameEdit: () => void;
  setEditingFile: (file: { id: number; name: string } | null) => void;
  handleDeleteFile: (id: number) => void;
  startEditingFile: (id: number) => void;
  getCategoryLabel: (value: string) => string;
}

export function FileListCard({
  files,
  editingFile,
  newFileName,
  setNewFileName,
  saveFileNameEdit,
  setEditingFile,
  handleDeleteFile,
  startEditingFile,
  getCategoryLabel
}: FileListCardProps) {
  return (
    <Card className="md:col-span-2">
      <CardHeader>
        <CardTitle>Λίστα Αρχείων</CardTitle>
      </CardHeader>
      <CardContent>
        <FileTable
          files={files}
          editingFile={editingFile}
          newFileName={newFileName}
          onNewFileNameChange={setNewFileName}
          onSaveEdit={saveFileNameEdit}
          onCancelEdit={() => setEditingFile(null)}
          onStartEdit={startEditingFile}
          onDeleteFile={handleDeleteFile}
          getCategoryLabel={getCategoryLabel}
        />
      </CardContent>
    </Card>
  );
}
